module.exports = __webpack_public_path__ + "static/media/EnglishiGOLogo.333eb2e5.png";